export interface BrandItemResponse {
    id: string;
    name: string;
    logoPath: string;
    logoId: string;
}

export const fetchLogos = async (): Promise<BrandItemResponse[]> => {
    const url = `/api/v1/brands/carousel`
    const result: Response = await fetch(url, {
        method: 'GET',
    });
    console.log('result', result)
    return result.json();
}

